import { Button } from "../../components/ui/button";

export const DeleteAssistantModal = ({
    open,
    onClose,
    onDelete,
    assistant = null,
    isDeleting = false,
}) => {
    if (!open) return null;

    const confirmMessage = `Are you sure you want to delete assistant "${assistant?.name}"?`;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
                <h3 className="text-lg font-semibold mb-4">Delete Assistant</h3>
                <p>{confirmMessage}</p>
                <div className="flex justify-end gap-2 mt-6">
                    <Button
                        type="button"
                        variant="outline"
                        onClick={onClose}
                        disabled={isDeleting}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        className="bg-red-700 text-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-red-600"
                        onClick={onDelete}
                        disabled={isDeleting}
                    >
                        {isDeleting ? (
                            <>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                Deleting...
                            </>
                        ) : (
                            "Delete"
                        )}
                    </Button>
                </div>
            </div>
        </div>
    );
};
